import type { FC } from 'react';
import { BreadcrumbChild } from './styled';

const BreadcrumbDivider: FC = ({ children = '/' }) => (
  <BreadcrumbChild>{children}</BreadcrumbChild>
);

BreadcrumbDivider.defaultProps = {
  hideSm: false,
};

export default BreadcrumbDivider;
